import React from 'react'
import 'firebase/firestore';
import Card from './Card';
import useFetchProdutos from './useFetchProdutos';
import Head from '../Head';
import BtnWhatsapp from '../BtnWhatsapp';


const FetchProdutos = () => {

  const {tortas } = useFetchProdutos()


  if(tortas === null) return null;
  return (
    <>
    <BtnWhatsapp />
    <Head title="Cantinho d' Bolos | Tortas" description="Esses São nossos produtos." />
      
    {tortas.map(item => <Card key={item.id} id={item.id} img={item.foto} nome={item.nome} precoG={item.precoG} precoM={item.precoM} precoP={item.precoP} tipo={item.tipo} usuario={item.usuario} visualizacoes={item.visualizacoes} descricao={item.descricao} /> )}
         
     
    </>
  )
}

export default FetchProdutos
